import { useGlue } from './useGlue';
import { useEffect, useState } from 'react';
import { GlueEvents } from '../glue';
export const useAuthentication = () => {
  const glue = useGlue();
  const [authentication, setAuth] = useState(glue.authentication);
  useEffect(() => glue.on(GlueEvents.AUTHENTICATION_SETUP, auth => {
    setAuth(auth);
  }));
  return authentication;
};